




















































import {Component, Prop} from 'vue-property-decorator'
import VueBase from '@/pages/vue-base'
import TinyMce from '@/components/admin/TinyMce.vue'
import {Medium} from '@/models/Medium'
import Interview from '@/models/Interview'
import MediaSelector from '@/components/admin/MediaSelector.vue'

@Component({
  components: {
    TinyMce,
    MediaSelector
  }
})
export default class AddinForm extends VueBase {
  @Prop(Object) readonly post!: Interview
  showedMediaSelector = false

  onSelectMedium(medium: Medium): void {
    this.post.profile_image = medium
    this.showedMediaSelector = false
  }
}
